module.exports = __webpack_public_path__ + "img/2_icn_sneaker.57b58fc1.png";